import type React from 'react'
import { Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { useFormatter } from '@api/useFormatter'

interface FooterTotalProps {
  value: number
}

export const FooterTotal: React.FC<FooterTotalProps> = ({ value }) => {
  const { formatCurrency } = useFormatter()
  const currencySymbol = formatCurrency(null, true)

  return (
    <Texto style={{ width: 120, textAlign: 'right' }}>
      {currencySymbol}
      {addCommasToNumber(value || 0, 2)}
    </Texto>
  )
}
